import React from 'react'
import 'sweetalert2/dist/sweetalert2.all';
import Swal from 'sweetalert2';
export default function alert_msg(title,icon) {
    const alert=()=>{
    

        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer;
              toast.onmouseleave = Swal.resumeTimer;
            }
          });
          Toast.fire({
            icon: icon,
            title:title
          });
    
    };
  return (
    alert()
  );
}
